import { useEffect, useState } from "react";
import { getPublicSupabaseClient } from "./lib/supabase";

export function EventPaymentNotice() {
  const [attempt, setAttempt] = useState(0);
  const [notice, setNotice] = useState<{
    tone: string;
    title: string;
    message: string;
    retry?: boolean;
  } | null>(null);
  // biome-ignore lint/correctness/useExhaustiveDependencies: The explicit retry counter deliberately restarts the request.
  useEffect(() => {
    let active = true;
    const params = new URLSearchParams(window.location.search);
    if (params.get("zahlung") === "abgebrochen" || params.get("beitrag") === "abgebrochen") {
      setNotice({
        tone: "pending",
        title: "Zahlung nicht abgeschlossen.",
        message:
          "Hier wurde keine Zahlung bestätigt. Falls du einen Zahlungslink per E-Mail erhalten hast, kannst du ihn innerhalb der Reservierungsfrist weiterverwenden. Ein freiwilliger Beitrag verändert deine bereits bestätigte Anmeldung nicht.",
      });
      return;
    }
    const sessionId = params.get("session_id");
    if (params.get("zahlung") !== "erfolgreich" || !sessionId) return;
    setNotice({
      tone: "pending",
      title: "Zahlungsstatus wird geprüft …",
      message: "Wir gleichen die Rückmeldung mit deiner Anmeldung ab.",
    });
    getPublicSupabaseClient()
      .functions.invoke("create-event-checkout", { body: { sessionId } })
      .then(({ data, error }) => {
        if (error || !data?.reconciled) throw error ?? new Error("payment_unconfirmed");
        if (!active) return;
        if (data.requiresReview) {
          setNotice({
            tone: "pending",
            title: "Wir müssen deine Anmeldung prüfen.",
            message:
              "Eine Zahlung liegt vor, aber dein Platz konnte nicht automatisch bestätigt werden. Bitte antworte auf deine Buchungsmail oder schreibe an hello@katrinundrayk.de. Bitte bezahle nicht erneut.",
          });
          return;
        }
        setNotice({
          tone: "success",
          title: "Du bist dabei.",
          message: data.emailsSent
            ? "Anmeldung und Zahlung sind bestätigt. Die Bestätigung wurde an den E-Mail-Versand übergeben."
            : "Anmeldung und Zahlung sind bestätigt. Der E-Mail-Versand ist noch nicht bestätigt. Bitte bezahle nicht erneut; bei Rückfragen sind wir unter hello@katrinundrayk.de erreichbar.",
        });
      })
      .catch(() => {
        if (active)
          setNotice({
            tone: "error",
            title: "Zahlungsstatus noch unklar.",
            message:
              "Die Rückmeldung konnte gerade nicht geprüft werden. Bitte prüfe erneut oder kontaktiere uns, bevor du noch einmal bezahlst.",
            retry: true,
          });
      });
    return () => {
      active = false;
    };
  }, [attempt]);
  if (!notice) return null;
  return (
    <div
      className={`public-events__payment-notice is-${notice.tone}`}
      role={notice.tone === "error" ? "alert" : "status"}
    >
      <strong>{notice.title}</strong>
      <span>{notice.message}</span>
      {notice.retry ? (
        <button type="button" onClick={() => setAttempt((value) => value + 1)}>
          Erneut prüfen
        </button>
      ) : null}
    </div>
  );
}
